import React, { useState, useEffect } from 'react';
import { Container, Button, Box, Modal, AppBar, Toolbar, Table, CircularProgress, TableContainer, TableCell, TableRow, TableHead, TableBody, Typography, Paper, Tooltip, InputAdornment, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from "@mui/icons-material/Search";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useParams } from "react-router-dom";
import base64 from "base64-js";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


function Religion() {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canSave, setCanSave] = useState(null);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [religions, setReligions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedreligion, setselectedreligion] = useState({ religionID: null, religionName: '' });
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [showModal, setShowModal] = useState(false);



  let navigate = useNavigate();

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanSave(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };


  const handleClick = () => {
    navigate('/addreligion');

  };

  const fetchReligions = async () => {
    try {
      setLoading(true); // Set loading to true when starting the fetch
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Religion/GetReligion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching religions: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error('Record Not Found');
        // alert('Record Not Found');
        setSnackbarMessage('Record Not Found');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
        setReligions([]); // Set religions to an empty array
      } else {
        setReligions(Array.isArray(data) ? data : data.data); // Ensure data is set correctly
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity('error');
      setReligions([]); // Set religions to an empty array on error
    } finally {
      setLoading(false); // Set loading to false after fetch completes
    }
  };


  const handleShow = (religionID, religionName) => {
    setselectedreligion({ religionID, religionName });
    setShowModal(true);
  };



  useEffect(() => {


    fetchReligions();
    Authorizer();
  }, []);

  const handleClose = () => {

    setShowModal(false);
  };

  const handleDelete = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Religion/Id?Id=${selectedreligion.religionID}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        }
      );
      if (response.ok) {
        // Handle success, e.g., refresh the data
        fetchReligions();
        setShowModal(false);
        setLoadingBarProgress(100);
        setSnackbarMessage('Religion deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity('success');
      } else {
        setLoadingBarProgress(0);
        console.error('Delete failed');
        // alert('Failed to delete religion');
        setSnackbarMessage('Failed to delete religion');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
      }
    } catch (error) {
      console.error('API request error:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  const filteredData = religions.filter((religion) =>
    religion.religionName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  return (
    <Container>
      {/* <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{ height: '120px', marginTop: '14px' }}>
        <div className="navbar-nav">
          <input className="form-check-input" style={{ marginTop: '15px' }} />
        </div>
      </nav> */}
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Religion
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>




        <div className="mb-3" style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', marginTop: '10px', gap: '0.5rem' }}>
          <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">

                  <SearchIcon />
                </InputAdornment>
              ),
              style: { padding: '0px 8px' },
            }}
            sx={{
              width: 300,
              backgroundColor: '#f9f9f9',
            }}
          />
          <Tooltip title={canSave ? "Add Religion" : "Not authorized to Add"} arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                className="my-2"
                disabled={!canSave}
                onClick={handleClick}
                // sx={{ height: 'fit-content' }}
                style={{
                  width: "160px",
                  height: "50px",
                  padding: "10px 0",
                  fontWeight: 'bold'
                }}

              >
                <b>ADD</b>
              </Button> </span> </Tooltip>
        </div>

        <TableContainer component={Paper} style={{ marginTop: '10px' }}>
          <Table sx={{
            minWidth: 650,
            border: '1px solid #ccc',
            '& .MuiTableCell-root': {
              borderRight: '1px solid #ccc',
              fontSize: '1rem',
            },
            '& .MuiTableHead-root .MuiTableCell-root': {
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
            },
          }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '1rem', fontWeight: 'bold', borderRight: '2px solid #ddd' }}>
                  Religion Name
                </TableCell>
                <TableCell sx={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center' }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((religion) => (
                  <TableRow key={religion.religionID}>
                    <TableCell sx={{ borderRight: '2px solid #ddd', fontSize: '0.95rem' }}>
                      {religion.religionName}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center', fontSize: '0.95rem' }}>
                      <Tooltip title={canEdit ? "Edit Religion" : "Not authorized to Edit"} arrow>
                        <span>
                          <Button
                            variant="contained"
                            color="warning"
                            disabled={!canEdit}
                            startIcon={<EditIcon />}
                            onClick={() => navigate(`/editreligion/${religion.religionID}`)}
                            style={{ marginRight: '5px' }}
                          >
                            <b>EDIT</b>
                          </Button>
                        </span>
                      </Tooltip>
                      <Tooltip title={canDelete ? "Delete Religion" : "Not authorized to delete"} arrow>
                        <span>
                          <Button
                            variant="contained"
                            color="error"
                            disabled={!canDelete}
                            startIcon={<DeleteIcon />}
                            onClick={() => handleShow(religion.religionID, religion.religionName)}
                          >
                            <b>DELETE</b>
                          </Button>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    No Religions Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </TableContainer>

        {filteredData.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}

        <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Delete Confirmation ⚠️
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: '20px' }}>
              <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                Are you sure you want to delete <strong>{selectedreligion?.religionName}</strong>?
              </Typography>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(handleDelete)}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
}

export default Religion;
// {selectedreligion?.religionName}